import React from 'react';
import {CardActions, CreateButton, Datagrid, Filter, List, TextField, TextInput} from 'react-admin';
import {
    BillAuthStatusField,
    DownloadFileContentButton,
    DownloadTemplateFileButton,
    EditButtonWithAuthStatus
} from "../../components";
import DeleteBillBatchtButton from "../../components/DeleteBillBatchButton";
import {BatchTypeField} from "./BatchType";


const EventBatchFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

const PostActions = ({
                         bulkActions,
                         basePath,
                         displayedFilters,
                         filters,
                         filterValues,
                         onUnselectItems,
                         resource,
                         selectedIds,
                         showFilter,
                     }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        {/* Add your custom actions */}
        <DownloadTemplateFileButton basePath="/api/pupilEnrollmentBatchV3s/getTemplate/HS_C1"
                                    btnLabel="ra.action.downloadTemplateCardApplication"/>
        <DownloadTemplateFileButton basePath="/api/pupilEnrollmentBatchV3s/getTemplate/STUDENT"
                                    btnLabel="ra.action.downloadTemplateStudentCardApplication"/>
        <CreateButton basePath={basePath}/>
    </CardActions>
);

export const PupilEnrollmentBatchV3List = props => (
    <List filters={<EventBatchFilter/>} {...props} actions={<PostActions/>} bulkActionButtons={false}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <BatchTypeField source="type"/>
            <BillAuthStatusField source="authStatus"/>
            <DownloadFileContentButton/>
            <EditButtonWithAuthStatus/>
            <DeleteBillBatchtButton title={"Bạn chắc chắn muốn huỷ lô học sinh?"}
                                    text={"Không thể hoàn tác sau khi huỷ."}
                                    successMessage={"Huỷ lô học sinh thành công!"}/>
        </Datagrid>
    </List>
);

export default PupilEnrollmentBatchV3List
